import type {
  BetterstartCommandRuntime,
  SeedCommandOptions
} from '@cli-types/core-engine/commands.js'
import { renderCommandHelpText } from '@core-engine/templates/renderers/commands/command-help.js'
import { Command } from 'commander'

export function createSeedCommand(runtime: BetterstartCommandRuntime): Command {
  return new Command('seed')
    .description('Create the initial admin user')
    .option('--email <email>', 'Admin email (required off-TTY)')
    .option(
      '--name <name>',
      'Admin display name (defaults to "Admin"); set the password via BETTERSTART_ADMIN_PASSWORD off-TTY'
    )
    .option('--cwd <path>', 'Project root path')
    .addHelpText('after', renderCommandHelpText('seed'))
    .action((options: SeedCommandOptions) => runtime.runSeed(options))
}
